/**
 * @type {import('gatsby').GatsbyBrowser}
 */
require("./src/styles/global.css")
